import { useMemo } from "react";
import { Grid } from "@mui/material";

// Components
import MxCatchmentEmptyState from "./components/MxCatchmentEmptyState";
import MxCatchmentTable from "./components/MxCatchmentTable";
import MxCatchmentFooter from "./FooterCatchMentForm";

// Hooks
import { useBuildingsContext } from "@rf/property/module/components/property-form/septions/property-steps/buildings-step/context/Buildings-contexts/BuildingsContext";

// Types
import { IMxCatchmentForm } from "./model/catchment.interface";

/**
 * Formulario principal para gestión de etapas del proyecto
 * Maneja el estado de edificios y proporciona la interfaz para CRUD
 */
export const MxCatchmentForm = ({
  onAddItem,
  onRemoveItem,
  onDuplicateItem
}: IMxCatchmentForm) => {
  const {
    addBuilding,
    deleteBuilding,
    duplicateBuilding,
    fields: buildings
  } = useBuildingsContext();

  /**
   * Agregar una nueva etapa/edificio
   */
  const handleAddItem = async () => {
    const buildingAdded = await addBuilding();
    onAddItem?.();
  };

  /**
   * Eliminar una etapa/edificio con validación
   */
  const handleRemoveItem = async (index: number) => {
    const buildingDeleted = await deleteBuilding(index);
    onRemoveItem?.(index);
  };

  /**
   * Duplicar una etapa/edificio existente
   */
  const handleDuplicateItem = async (index: number) => {
    const buildingDuplicated = await duplicateBuilding(index, 1);
    onDuplicateItem?.(index);
  };

  const isEmpty = useMemo(() => !buildings || buildings.length === 0, [buildings]);

  return (
    <Grid container>
      {isEmpty && <MxCatchmentEmptyState onAdd={handleAddItem} />}

      {!isEmpty && (
        <MxCatchmentTable
          buildings={buildings}
          duplicateItem={handleDuplicateItem}
          removeItem={handleRemoveItem}
        />
      )}

      {!isEmpty && <MxCatchmentFooter addItem={handleAddItem} />}
    </Grid>
  );
};

export default MxCatchmentForm;
